import { FunctionComponent, useState } from 'react';
import Slider from 'react-slick';
import FursysBenefit2Wrapper from './fursysBenefit2.style';
import { getStaticImageUrl } from '@utils/createImageUrl';
import ArrowRightIcon from '../../public/icon/ArrowRight';
import ArrowLeftIcon from '../../public/icon/ArrowLeft';

const FursysBenefit2: FunctionComponent = () => {
  const FursysMain = [
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-interior-banner-1.jpg' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-interior-banner-1.jpg' }),
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-interior-banner-2.jpg' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-interior-banner-2.jpg' }),
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-interior-banner-3.jpg' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-interior-banner-3.jpg' }),
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = {
    className: 'slider variable-width',
    centerMode: false,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (_: number, next: number) => {
      setCurrentSlide(next);
    },
  };

  const mobileSettings = {
    centerMode: false,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    dots: true,
    dragAble: true,
    arrows: false,
  };
  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide > 0) {
      return (
        <div
          className={className}
          style={{
            ...style,
            left: 'calc(50% - 604px)',
            top: 'calc(50% - 17px)',
            zIndex: '2',
          }}
          onClick={onClick}
        >
          <ArrowLeftIcon />
        </div>
      );
    } else {
      return <></>;
    }
  }
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide < FursysMain.length - 1) {
      return (
        <div
          className={className}
          style={{
            ...style,
            left: 'calc(50% + 576px)',
            top: 'calc(50% - 17px)',
            zIndex: '5',
          }}
          onClick={onClick}
        >
          <ArrowRightIcon />
        </div>
      );
    } else {
      return <></>;
    }
  }
  return (
    <FursysBenefit2Wrapper>
      <p className="benfit">혜택</p>
      <p className="slidTitle">
        개업의 시작, 인테리어.
        <br />
        전문가들이&nbsp;
        <br className="mobile" />
        도와드리겠습니다.
      </p>
      <p className="slideDescription">
        디자이너와 분야별 전문시공자들이&nbsp;
        <br className="mobile" />
        변호사님의 Needs & Wants 맞춰
        <br />
        최적의 사무공간 디자인과 설계를 제공합니다.
      </p>
      <div className="fursysbrand--list desktop">
        <Slider {...settings}>
          {FursysMain.map((process, index) => (
            <div className="fursysbrand--item" key={index}>
              <img className="solutionprocess--item-image" src={process.desktopImage} />
            </div>
          ))}
        </Slider>
      </div>

      <div className="fursysbrand--list-mobile mobile">
        <Slider {...mobileSettings}>
          {FursysMain.map((process, index) => (
            <div className="item" key={index}>
              <img className="solutionprocess--item-image" src={process.mobileImage} />
            </div>
          ))}
        </Slider>
      </div>
    </FursysBenefit2Wrapper>
  );
};

export default FursysBenefit2;
